import { Footer as MantineFooter, Container, Group, Text, Anchor } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

export function Footer() {
  const navigate = useNavigate();

  return (
    <MantineFooter height={80}>
      <Container fluid px={0}>
        <Group position="apart" h={80} px="md">
          <Text color="dimmed" size="sm">© 2024 Performance Management Portal</Text>
          <Group spacing="lg">
            <Anchor
              component="button"
              size="sm"
              onClick={() => navigate('/terms')}
              sx={(theme) => ({
                color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[6],
                '&:hover': {
                  textDecoration: 'none',
                  color: theme.colorScheme === 'dark' ? theme.white : theme.black,
                }
              })}
            >
              Terms of Service
            </Anchor>
            <Text color="dimmed" size="sm">•</Text>
            <Anchor
              component="button"
              size="sm"
              onClick={() => navigate('/privacy')}
              sx={(theme) => ({
                color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[6],
                '&:hover': {
                  textDecoration: 'none',
                  color: theme.colorScheme === 'dark' ? theme.white : theme.black,
                }
              })}
            >
              Privacy Policy
            </Anchor>
          </Group>
        </Group>
      </Container>
    </MantineFooter>
  );
} 